import App from "./../app.jsx";
import { Navigate } from "react-router-dom";
import PublicRoute from "../_helpers/PublicRoute.js";
import Register from "../pages/Register.jsx";
import LandingPage from "../pages/User/LandingPage/LandingPage.jsx";
// import AdminDashboard from "../pages/Admin/AdminDashboard.jsx";
import Member from "../pages/Admin/Master/Member/Member.jsx";
import CreateCommittee from "../pages/Admin/Master/Committee/CreateOrEditCommittee.jsx";
import Committee from "../pages/Admin/Master/Committee/Committee.jsx";
import CreateOrEditMember from "../pages/Admin/Master/Member/CreateOrEditMember.jsx";
import CommitteePageIntegration from "../pages/Admin/CommitteePages/CommitteePageIntegration.jsx";
import CommitteeLandingPage from "../pages/User/Commitee/CommitteeLandingPage.jsx";
import EditCommitteePageIntegrate from "../pages/Admin/CommitteePages/EditCommitteePages.jsx";
import HomePageIntegration from "../pages/Admin/MainPage/HomePageIntegration.jsx";
import ForgotPassword from "../pages/ForgotPassword.jsx";
import ResetPassword from "../pages/ResetPassword.jsx";
// import BannerContent from "../pages/User/Commitee/CommitteeBannerContent.jsx";
import ChangePassword from "../pages/ChangePassword.jsx";
import AdminChangePassword from "../components/header/dropdown/AdminChangePassword.jsx";
import CommitteeMemberPage from "../pages/User/Commitee/CommitteeMemberPage.jsx";
import AdminLogin from "../pages/Admin/AdminLogin.jsx";
import UserLogin from "../pages/UserLogin.jsx";
import OTP from "../pages/OTP.jsx";
import AdminResetPassword from "../pages/Admin/AdminResetPassword.jsx";
import PrivateRoute from "../_helpers/PrivateRoute.jsx";
import AdminPrivateRoute from "../_helpers/AdminPrivateRoute.jsx";
import CommitteeDocumentPage from "../pages/User/Commitee/CommitteeDocumentPage.jsx";
import CreateOrEditMenu from "../pages/Admin/Master/Menu/CreateOrEditMenu.jsx";
import MenuList from "../pages/Admin/Master/Menu/MenuList.jsx";
import Error from "../pages/error.js";
import Category from "../pages/Admin/Master/DocCategory/Category.jsx";
import AddorEditCategory from "../pages/Admin/Master/DocCategory/AddorEditCategory.jsx";
import CommitteeBannerContent from "../pages/User/Commitee/CommitteeBannerContent.jsx";
import MyProfile from "../pages/MyProfile.jsx";
import AdminForgotPassword from "../pages/Admin/AdminForgotPassword.jsx";
import AdminMyProfile from "../pages/Admin/AdminMyProfile.jsx";
import MenuIntegration from "../pages/Admin/Master/Menu/MenuIntegration.jsx";
import AdminDashboard from "../pages/Admin/Dashboard/AdminDashboard.jsx";
import InnerPage from "../pages/User/InnerPage/InnerPage.jsx";
import Verification from "../pages/Verification.jsx";
import CommitteeCategoryPage from "../pages/Admin/CommitteePages/Pages/CommitteeCategoryPage.jsx";
import ViewAllCommittees from "../pages/User/ViewAllCommittees.jsx";
import PublicEvents from "../pages/Admin/PublicEvent/PublicEvents.jsx";
import AddOrEditPublicEvents from "../pages/Admin/PublicEvent/AddOrEditPublicEvents.jsx";
import AuthenticateRouter from "../_helpers/AuthenticateRouter.js";
import MembershipReport from "../pages/Admin/Reports/MembershipReport.jsx";
import LoginReport from "../pages/Admin/Reports/LoginReport.jsx";
import PrivacyPolicy from "../pages/User/PrivacyPolicy.jsx";

const AppRoute = [
  {
    path: "/",
    element: <Navigate to="/home" replace />,
  },
  {
    path: "/Admin",
    element: <Navigate to="/Admin/login" replace />,
  },
  // {
  //   path: "Committee",
  //   element: <CommitteeBannerContent />,
  // },

  {
    path: "",
    element: <App />,
    children: [
      {
        path: "*",
        element: <Error />,
      },

      {
        path: "Home",
        element: <LandingPage />,
      },
      {
        path: "login",
        element: <UserLogin />,
      },
      {
        path: "register",
        element: <Register />,
      },
      {
        path: "myprofile",
        element: <MyProfile />,
      },
      {
        path: "forgotPassword",
        element: <ForgotPassword />,
      },
      {
        path: "/changePassword",
        element: <ChangePassword />,
      },
      {
        path: "/verification",
        element: <Verification />,
      },
      {
        path: "/resetPassword/:token",
        element: <ResetPassword />,
      },
      {
        path: "/BPKCommittees",
        element: <ViewAllCommittees />,
      },
      {
        path: "Committee/:committeeID",
        element: <CommitteeBannerContent />,
      },
      {
        path: "Subpage/:url",
        element: <InnerPage />,
      },

      {
        path: "/login/OTP",
        element: <OTP />,
      },
      {
        path: "/register/OTP",
        element: <OTP />,
      },

      {
        path: "/changePassword",
        element: <ChangePassword />,
      },
      {
        path: "PrivacyPolicy",
        element: <PrivacyPolicy />,
      },
    ],
  },

  /*************** Admin ******************/
  {
    path: "Admin",
    element: (
      <AuthenticateRouter>
        <App />
      </AuthenticateRouter>
    ),
    children: [
      {
        path: "changePassword",
        element: <AdminChangePassword />,
      },
      {
        path: "myProfile",
        element: <AdminMyProfile />,
      },
      {
        path: "Dashboard",
        element: <AdminDashboard />,
      },
      {
        path: "Member",
        element: <Member />,
      },
      // {
      //   path: "AdditionalResource",
      //   element: <AdditionalResourceList />,
      // },
      // {
      //   path: "AdditionalResource/createorEdit",
      //   element: <CreateOrEditResource />,
      // },
      {
        path: "Member/createorEdit",
        element: <CreateOrEditMember />,
      },
      {
        path: "Committee",
        element: <Committee />,
      },
      {
        path: "Committee/createOrEdit",
        element: <CreateCommittee />,
      },
      {
        path: "Menu",
        element: <MenuList />,
      },
      {
        path: "Menu/createOrEdit",
        element: <CreateOrEditMenu />,
      },
      {
        path: "PublicEvents",
        element: <PublicEvents />,
      },
      {
        path: "PublicEvents/CreateOrEdit",
        element: <AddOrEditPublicEvents />,
      },
      {
        path: "HomePage",
        element: <HomePageIntegration />,
      },
      {
        path: "CommitteePage",
        element: <CommitteePageIntegration />,
      },
      {
        path: "CommitteeCategoryPage",
        element: <CommitteeCategoryPage />,
      },
      {
        path: "CommitteePage/:commiteePageID",
        element: <EditCommitteePageIntegrate />,
      },

      {
        path: "DocCategory",
        element: <Category />,
      },
      {
        path: "DocCategory/CreateOrEdit",
        element: <AddorEditCategory />,
      },
      {
        path: "Menu/subpage",
        element: <MenuIntegration />,
      },
      {
        path: "Report/Membership",
        element: <MembershipReport />,
      },
      {
        path: "Report/Login",
        element: <LoginReport />,
      },
    ],
  },

  {
    path: "Admin/login",
    element: <AdminLogin />,
  },
  {
    path: "Admin/forgotPassword",
    element: (
      // <PublicRoute>
      <AdminForgotPassword userType="admin" />
      // </PublicRoute>
    ),
  },
  {
    path: "/Admin/resetPassword/:token",
    element: <AdminResetPassword userType="admin" />,
  },
];

export default AppRoute;
